
import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class SortTypeServicesCommand extends IRequestCommand<boolean, ErrorDetails, number[]> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;
  override _commandUrl = 'carrier/users/{userId}/transportTypes/order';

  public setUrlParameters(carrierId: string) {
    this._commandUrl = this._commandUrl.replace('{userId}', carrierId.toString());
  }
}
